/** Logo API URL scoped by instance + bust so browser cache cannot bleed across instances. */
export function companyLogoSrc(instanceId: string, bust = 0): string {
  const i = encodeURIComponent(instanceId.trim() || 'default');
  const t = Number.isFinite(bust) ? Math.max(0, Math.floor(bust)) : 0;
  return `/api/settings/company/logo?instance=${i}&t=${t}`;
}

export function instanceIdFromPathname(pathname: string): string {
  const match = pathname.match(/^\/i\/([^/]+)/);
  return match ? decodeURIComponent(match[1]) : 'default';
}

/** Load logo as data URL for PDF renderers (no redirect/cookie quirks). */
export async function fetchCompanyLogoDataUrl(
  instanceId: string,
  bust: number,
): Promise<string | null> {
  try {
    const res = await fetch(companyLogoSrc(instanceId, bust), {
      credentials: 'include',
      cache: 'no-store',
    });
    if (!res.ok) return null;
    const blob = await res.blob();
    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => {
        resolve(typeof reader.result === 'string' ? reader.result : null);
      };
      reader.onerror = () =>
        reject(reader.error ?? new Error('Logo konnte nicht gelesen werden.'));
      reader.readAsDataURL(blob);
    });
  } catch {
    return null;
  }
}
